import styled from 'styled-components'
import Botao from '../Mantine/Botao'
import { DragOverlay } from '@dnd-kit/core'

export const QuickButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-x: hidden;
  min-width: 0;
`

export const Header = styled.div`
  /* margin-bottom: 30px; */
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border-radius: 8px;
  overflow-x: hidden;
  min-width: 0;
`

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.cor9}!important;
`

export const Description = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.cor9}!important;
  margin: 0;
`

export const TitleWithButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const SectionTransition = styled.div`
  opacity: ${({ $isTransitioning }) => ($isTransitioning ? 0.5 : 1)};
  pointer-events: ${({ $isTransitioning }) => ($isTransitioning ? 'none' : 'auto')};
  transition: opacity 0.3s ease;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const EmptyStateCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 18px;
  border-radius: 8px;
  border: 1px ${({ theme, isOver }) => (isOver ? `dashed ${theme.cor9}` : `solid ${theme.cor54}`)};
  background-color: ${({ theme }) => theme.cor40}!important;
  min-height: ${({ isOver }) => (isOver ? '131px' : '120px')};
  text-align: center;
  transition: border-color 0.2s ease;
`

export const EmptyStateText = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.cor54}!important;
  margin: 0;
  margin-top: 8px;
`

export const EmptyFilteredText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  text-align: center;
  color: ${({ theme }) => theme.cor54}!important;
  font-size: 14px;
`

export const SubtleButton = styled(Botao)`
  padding: 0 !important;
  min-width: auto !important;
  height: auto !important;
`

export const DragOverlayOverlay = styled(DragOverlay)`
  opacity: 0.85;
`